import type { useTranslationDefault } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import {
	getBackendErrorMessage,
	isForbiddenApiError,
	isStandardBackendError,
} from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';

type TranslateDefault = ReturnType<typeof useTranslationDefault>;

/**
 * Shared `onError` handler for the signer mutation hooks.
 */
export const createSignerMutationErrorHandler =
	(tDefault: TranslateDefault) =>
	(error: unknown): void => {
		if (isForbiddenApiError(error)) {
			showToastV2({
				state: 'error',
				title: tDefault('common_api_wrapper.forbidden.message', {
					defaultValue: "You don't have permission to access this resource.",
				}),
			});
			return;
		}
		if (isStandardBackendError(error)) {
			showToastV2({
				state: 'error',
				title: tDefault(`error_codes.${error.error?.code}`),
			});
			return;
		}
		const backendMessage = getBackendErrorMessage(error);
		if (backendMessage) {
			showToastV2({
				state: 'error',
				title: backendMessage,
			});
			return;
		}
		showToastV2({
			state: 'error',
			title: tDefault('common.toast.error.message'),
		});
	};
